
export default {
  props: {
    description: {
      type: String,
      required: true,
    },
  },
}
